<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div>
          <div class="label-input">Section Background</div>
          <div class="mb-5 group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.background.color"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field hide-details v-model="fields.background.color" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field hide-details v-model="fields.textColor" label="Text Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.top" label="Top Padding" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="label-input">Content Background</div>
          <div class="mb-5 group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background-content"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.backgroundContent.color"
                    @change="handleChangeBackgroundContentColor"
                  />
                  <v-text-field
                    hide-details
                    v-model="fields.backgroundContent.color"
                    label="Background Content Color"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="mb-3">
            <div class="label-input">Title Content</div>
          </div>
          <div class="group-item mb-5">
            <v-checkbox class="mt-0" v-model="fields.titleContent.show" label="Show" />
            <ckeditor :editor="editor" v-model="fields.titleContent.htmlContent" :config="editorConfig" />
          </div>
        </div>

        <div>
          <div class="mb-3">
            <div class="label-input">Image</div>
          </div>
          <div class="group-item mb-5">
            <v-row>
              <v-col cols="12" md="6">
                <UploadImage
                  @callback="handleUploadImage"
                  :image="{ imageSrc: fields.img.src }"
                  :height="`250`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveImage"
                />
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-5">
                  <v-checkbox v-model="fields.img.show" label="Show image" hide-details />
                </div>
                <v-text-field v-model.number="fields.img.width" type="number" label="Image width (px)" />
              </v-col>
              <!-- <v-col cols="12" md="6"> </v-col> -->
            </v-row>
          </div>
        </div>

        <div>
          <div class="mb-3">
            <div class="label-input">Description Content</div>
          </div>
          <div class="group-item mb-5">
            <ckeditor :editor="editor" v-model="fields.descriptionContent" :config="editorConfig" />
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';

export default {
  name: 'ImageWithTextBasic',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Section Image With Text Basic',
        textColor: '#000000',
        enableAnchor: false,
        padding: {
          top: true,
          bottom: true,
        },
        background: {
          color: '#ffffff',
        },
        backgroundContent: {
          color: '#fefdf0',
        },
        titleContent: {
          htmlContent: `
            <h2>Your Purchase Is Protected By Our</h2>
            <h2>90-Day "Sleep In Peace" Guarantee</h2>
            <p>Here at Haven, we make sure our customers feel safer — or we refund 100% of their investment. We're so
              confident you'll finally sleep knowing your family is protected that we'll bear all the risk.</p>
          `,
          show: true,
        },
        img: {
          src: '',
          width: 200,
          show: true,
        },
        descriptionContent: `
          <p>Your purchase is protected by our 90-day "Sleep In Peace" guarantee. We're so confident you'll finally sleep
            knowing your family is protected that we'll bear all the risk.</p>
        `,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      titleContent: {
        ...this.fields.titleContent,
        ...(this.sectionEditor.sectionExtract?.titleContent || {}),
      },
      img: {
        ...this.fields.img,
        ...(this.sectionEditor.sectionExtract?.img || {}),
      },
      background: {
        ...this.fields.background,
        ...(this.sectionEditor.sectionExtract?.background || {}),
      },
      backgroundContent: {
        ...this.fields.backgroundContent,
        ...(this.sectionEditor.sectionExtract?.backgroundContent || {}),
      },
      padding: {
        ...this.fields.padding,
        ...(this.sectionEditor.sectionExtract?.padding || {}),
      },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionImageWithTextBasic(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeBackgroundColor(event) {
      this.fields.background.color = event.target.value;
    },
    handleChangeBackgroundContentColor(event) {
      this.fields.backgroundContent.color = event.target.value;
    },
    handleChangeTextColor(event) {
      this.fields.textColor = event.target.value;
    },
    handleUploadImage(obj) {
      this.fields.img.src = obj.imageSrc;
    },
    handleRemoveImage() {
      this.fields.img.src = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  // padding: 16px;
  // border-radius: 20px;
  // background-color: #fefdf0;
}
</style>
